import { render, staticRenderFns } from "./StrongItem.vue?vue&type=template&id=cd13b1b2&scoped=true&"
import script from "./StrongItem.vue?vue&type=script&lang=js&"
export * from "./StrongItem.vue?vue&type=script&lang=js&"
import style0 from "./StrongItem.vue?vue&type=style&index=0&id=cd13b1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd13b1b2",
  null
  
)

export default component.exports